import Repository from "../Repository";

const resource = "/groups";
export default {
    get(){
        return Repository.get(`${resource}`);
    },
    getGroup(id){
        return Repository.get(`${resource}/${id}`);
    },
    createGroup(json){
        return Repository.post(`${resource}`,json);
    },
    updateGroup(id,json){
        return Repository.put(`${resource}/${id}`,json);
    },
    deleteGroup(id){
        return Repository.delete(`${resource}/${id}`);
    }
}